import useSite from '~/client/hooks/useSite';
import ProviderGames from './ProviderGames';
import ProviderInfo from './ProviderInfo';
import ProviderCardContainer from './styles/ProviderCardContainer';
import type { CasinoProviderGameFragment } from '../../graphql/ProvidersListQuery.generated';

type Props = {
  name: string;
  handle: string;
  count: number;
  games: CasinoProviderGameFragment[];
  sendToGtm: (action?: string) => void;
};

const ProviderCardDesktop: FC<Props> = ({
  name,
  count,
  handle,
  games,
  sendToGtm,
}) => {
  const { isLivecasino } = useSite();

  return (
    <ProviderCardContainer template="front" isLivecasino={isLivecasino}>
      <ProviderInfo
        name={name}
        handle={handle}
        count={count}
        sendToGtm={sendToGtm}
      />
      <ProviderGames games={games} sendToGtm={sendToGtm} />
    </ProviderCardContainer>
  );
};

export default ProviderCardDesktop;
